import { render, staticRenderFns } from "./wh8.vue?vue&type=template&id=57c948f1&scoped=true&"
import script from "./wh8.vue?vue&type=script&lang=js&"
export * from "./wh8.vue?vue&type=script&lang=js&"
import style0 from "./wh8.vue?vue&type=style&index=0&id=57c948f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c948f1",
  null
  
)

export default component.exports